import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../context/AuthContext";
import { LoadingButton } from "@mui/lab";
import SelectMultipleCompanyEmployee from "../../QuoteForm/SelectMultipleCompanyEmployees";

const SendQuoteDialog = ({ quote, open, handleClose, onQuoteSent }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [finalizeQuoteEmailReceivers, setFinalizeQuoteEmailReceivers] =
    useState([]);
  const [sendQuoteCopyTo, setSendQuoteCopyTo] = useState([]);
  const [finalizeEstimateEmailText, setFinalizeEstimateEmailText] =
    useState("");
  const resetDefaultEstimateEmailText = () => {
    let defaultEstimateEmailText = `Hi,\n\n[[LINK]]\n\nThank you for letting us quote this project. If everything looks correct, please approve by clicking on the link above, then clicking "Approve".\n\nWe appreciate you choosing Industry Metal Co and look forward to working with you!\n\nThank you,`;
    setFinalizeEstimateEmailText(defaultEstimateEmailText);
  };

  const resendEstimate = async (emailBody, sendTo) => {
    try {
      setLoading(true);
      const response = await ezorder.post(
        `/admin/orders/${quote.id}/estimate/resend`,
        {
          emailBody,
          sendTo,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status == 200 || response.status === 201) {
        setErrorMessage("");
        handleClose();
        resetDefaultEstimateEmailText();
        onQuoteSent();
      } else {
        if (
          response &&
          response.response &&
          response.response.data &&
          response.response.data.error
        ) {
          setErrorMessage(response.response.data.error);
        } else {
          setErrorMessage("Something went wrong");
        }
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.data?.error) {
          setErrorMessage(error.response.data.error);
        } else {
          setErrorMessage("Internal server error");
        }
      } else {
        setErrorMessage("Internal server error");
      }
      setLoading(false);
    }
  };

  const sendEstimate = async (emailBody, sendTo) => {
    try {
      setLoading(true);

      let formData = new FormData();
      formData.append("orderId", quote.id);
      formData.append("status", "ESTIMATE_APPROVAL_NEEDED");
      formData.append("data", JSON.stringify({ emailBody, sendTo }));

      const response = await ezorder.patch(
        `/admin/orders/${quote.id}/status`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "content-type": "multipart/form-data",
          },
        }
      );
      if (response.status == 200 || response.status === 201) {
        setErrorMessage("");
        handleClose();
        resetDefaultEstimateEmailText();
        onQuoteSent();
      } else {
        if (
          response &&
          response.response &&
          response.response.data &&
          response.response.data.error
        ) {
          setErrorMessage(response.response.data.error);
        } else {
          setErrorMessage("Something went wrong");
        }
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.data?.error) {
          setErrorMessage(error.response.data.error);
        } else {
          setErrorMessage("Internal server error");
        }
      } else {
        setErrorMessage("Internal server error");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (quote && quote.project) {
      resetDefaultEstimateEmailText();
    }
  }, [quote]);

  useEffect(() => {
    if (quote && quote.estimateRequestedBy) {
      setSendQuoteCopyTo([quote.estimateRequestedBy]);
    }
  }, [quote.estimateRequestedBy]);

  useEffect(() => {
    console.log("sendQuoteCopyTo", sendQuoteCopyTo);
  }, [sendQuoteCopyTo]);

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        if (!loading) {
          handleClose();
          resetDefaultEstimateEmailText();
        }
      }}
    >
      <DialogTitle>
        {quote.orderStatus.name == "ESTIMATE_APPROVAL_NEEDED"
          ? "Re-Send Quote for Approval"
          : "Finalize & Send Quote for Approval"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ paddingTop: "8px" }}>
          <SelectMultipleCompanyEmployee
            required
            disabled={!quote.company}
            companyId={quote.company ? quote.company.id : null}
            value={sendQuoteCopyTo}
            onUpdate={(users) => {
              setSendQuoteCopyTo(users);
            }}
            label="Send To"
            enableAdd={true}
          />
        </Box>

        <TextField
          sx={{ marginTop: "16px" }}
          fullWidth
          variant="outlined"
          label="Email Body"
          name="emailBody"
          multiline
          rows={8}
          size="small"
          value={finalizeEstimateEmailText}
          onChange={(e) => {
            setFinalizeEstimateEmailText(e.target.value);
          }}
          helperText="The system will replace [[LINK]] with the actual link when it sends out this email."
        />
      </DialogContent>
      <Box
        sx={{
          m: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {errorMessage && (
          <Box>
            <Typography color={"red"}>{errorMessage}</Typography>
          </Box>
        )}
      </Box>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) {
              handleClose();
              resetDefaultEstimateEmailText();
            }
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          loading={loading}
          variant="contained"
          color="primary"
          onClick={() => {
            if (quote.orderStatus.name == "ESTIMATE_APPROVAL_NEEDED") {
              resendEstimate(finalizeEstimateEmailText, sendQuoteCopyTo);
            } else {
              sendEstimate(finalizeEstimateEmailText, sendQuoteCopyTo);
            }
          }}
        >
          Send
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default SendQuoteDialog;
